(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-carousel')) {
    class BrandCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.ticking = false;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.update(); this.ticking = false; });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));

        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.track);
        this.update();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.ro?.disconnect();
        this.io?.disconnect();
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.track.clientWidth + gap;
      }

      go(dir, loop = false) {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth - 2;
        if (loop && t.scrollLeft >= max) {
          t.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        t.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        this.classList.toggle('is-static', max <= 2);
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      }

      setupAutoplay() {
        const seconds = parseInt(this.dataset.autoplay, 10);
        if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && Shopify.designMode) return; // pas d'autoplay dans l'éditeur

        this.paused = false;
        this.visible = false;
        const pause = () => { this.paused = true; };
        const resume = () => { this.paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.addEventListener('touchstart', pause, { passive: true });
        this.addEventListener('touchend', resume, { passive: true });

        this.io = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; });
        this.io.observe(this);

        this.timer = setInterval(() => {
          if (this.visible && !this.paused && !document.hidden && !this.classList.contains('is-static')) {
            this.go(1, true);
          }
        }, seconds * 1000);
      }
    }
    customElements.define('brand-carousel', BrandCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
